import { IGoal } from "motw_core/Entity/IGoal";
import { State } from "source/app/services/UI/State/State";
import { ICalendarState } from "../../../Calendar/ICalendarState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { CalendarEvent } from "../../../Calendar/CalendarEventUtils/CalendarEvent";

export function GetMatchingCalendarEvent(goal: IGoal) {
    const calendar = State.ReadClass<ICalendarState>(ESharedComponent.Calendar);

    if (!calendar.state.eventData) {
        return undefined;
    }

    const matchingCalendarEvent = calendar.state.eventData.find(
        (event) =>
            event.matchingGoal?.id === goal.id &&
            new CalendarEvent(event).IsToday
    );

    return matchingCalendarEvent;
}
